<swal #currentSwal title="Operación" text="Operación realizada" icon="info"></swal>
<swal #notesSwal title="Operación" text="Operación realizada" icon="info"></swal>

<!-- <h1>{{fileIdValue ? fileIdValue: 'Sin id por ruta'}}</h1> -->
<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }" [template]="customLoadingTemplate"></ngx-loading>
<ng-template #customLoadingTemplate></ng-template>
<div class="app-content content">
	<div class="content-wrapper">
		<div class="content-header row mb-1"></div>
		<div class="content-detached">
			<div class="content-body">
				<!-- insertar barra de busqueda -->
				<app-search-bar
					[criterioPrincipal]="configLocal.barraBusqueda.criterioPrincipal"
					[config]="configLocal.barraBusqueda"
					[filtroDTE]="true"
					[filtroEstadoSii]="true"
					[filtroEstadoDte]="true"
					[filtroImportado]="true"
					[filtroReutilizado]="true"
					[filtroAnulados]="true"
					[filtroPuedenCederse]="true"
					[nombreCampoDatePicker]="configLocal.barraBusqueda.nombreCampoDatePicker"
					(busqueda)="searchElementsByFilter($event)"
					[useAccordionMode]="true"
					[filtroEmisor]="true"
					[filtroSucursal]="true"
					[mostrarListaCompletaEmisores]="isSuperAdmin"
					[filtroAcuseEmitidos]="true"
					[emisorClearable]="false"
					[sucursalClearable]="false"
					[filtroPendientePago]="true"
					[fechaInicio]="fechaInicioDefault"
					[fechaFin]="fechaFinDefault"
					[filtroMultiple]="true">
				</app-search-bar>
				<section class="row">
					<div class="col-12">
						<div class="card card-custom">
							<div class="card-header">
								<h4 class="card-title">
									{{ configLocal.table.title
									}}{{
										filterDescription
											? " -
									" + filterDescription
											: ""
									}}
								</h4>
								<div *ngIf="maxDTE > 0" class="card-toolbar">DTEs: {{ cantidadDTE }} |{{ maxDTE }}</div>
								<div *ngIf="maxDTE < 0" class="card-toolbar">DTEs: {{ cantidadDTE }} | Ilimitado</div>
							</div>
							<div class="card-head">
								<div class="heading-elements mt-0">
									<div ngbDropdown>
										<button ngbDropdownToggle id="dropdownAccionesMasivas" ngbTooltip="Acciones masivas para documentos" class="btn btn-secondary float-right mr-5 mt-5 d-none d-md-block">
											<i class="flaticon-list-3"></i>
											Acciones Masivas
										</button>
										<div ngbDropdownMenu aria-labelledby="dropdownAccionesMasivas" class="dropdown-menu-right">
											<!-- Enviar Email Masivo -->
											<button class="buttonMantenedor" ngbDropdownItem data-gtm-id="enviar-email-masivo" data-gtm-group="dte-emitidos" (click)="openMassEmailModal(dteSenderModal)" *ngIf="permissions.getPermission('40-18-20').asignado">
												<i class="flaticon-envelope mr-3"></i>
												Enviar Email Masivo
											</button>
											<button class="buttonMantenedor" ngbDropdownItem data-gtm-id="enviar-cobranza-masivo" data-gtm-group="dte-emitidos" (click)="tryEnviarCobranzaMasivoConfirm()" ngbTooltip="Envía link/QR de pago a los DTE Pendientes seleccionados" *ngIf="permissions.getPermission('83-14').asignado">
												<i class="flaticon-paper-plane-1 mr-3"></i>
												Enviar Cobranza
											</button>
											<!-- Reutilizar Folios Masivo -->
											<button class="buttonMantenedor" ngbDropdownItem data-gtm-id="reutilizar-folios-masivo" data-gtm-group="dte-emitidos" (click)="tryMassiveRouseConfirm()" *ngIf="permissions.getPermission('40-18-46').asignado">
												<i class="flaticon-download-1 mr-3"></i>
												Reutilizar Folios
											</button>
											<!-- Exportar Documentos -->
											<button class="buttonMantenedor" ngbDropdownItem data-gtm-id="exportar" data-gtm-group="dte-emitidos" (click)="openExportModal()" *ngIf="permissions.getPermission('40-18-16').asignado">
												<i class="flaticon-download-1 mr-3"></i>
												Exportar Documentos
											</button>
											<!-- Separador -->
											<div class="text-divider" *ngIf="permissions.getPermission('40-18-12').asignado">
												<small>Descargar documentos</small>
											</div>

											<!-- Descarga PDF -->
											<button class="buttonMantenedor" ngbDropdownItem data-gtm-id="descarga-pdf" data-gtm-group="dte-emitidos" (click)="multipleDocumentDownload('pdf')" *ngIf="permissions.getPermission('40-18-12').asignado">
												<i class="flaticon-download mr-3"></i>
												Descarga PDF
											</button>
											<!-- Descarga XML -->
											<button class="buttonMantenedor" ngbDropdownItem data-gtm-id="descarga-xml" data-gtm-group="dte-emitidos" (click)="multipleDocumentDownload('xml')" *ngIf="permissions.getPermission('40-18-12').asignado">
												<i class="flaticon-download mr-3"></i>
												Descarga XML
											</button>
										</div>
									</div>
									<div ngbDropdown>
										<button ngbTooltip="Si necesitas traer DTEs que estén en el SII y no aquí" ngbDropdownToggle id="dropdownConciliacion" class="btn btn-info float-right mr-5 mt-5" *ngIf="permissions.getPermission('40-18-42').asignado">
											<i class="flaticon-refresh"></i>
											Importar desde el SII
										</button>
										<div ngbDropdownMenu aria-labelledby="dropdownConciliacion">
											<button class="buttonMantenedor" *ngIf="permissions.getPermission('40-18-42').asignado" ngbDropdownItem data-gtm-id="sincronizar-mes" data-gtm-group="dte-emitidos" (click)="openDatePickerImportedDte(datePickerImportedDteSiiModal, true)">Importación por Mes</button>
											<button class="buttonMantenedor" *ngIf="permissions.getPermission('40-18-42').asignado" ngbDropdownItem data-gtm-id="sincronizar-dia" data-gtm-group="dte-emitidos" (click)="openDatePickerImportedDte(datePickerImportedDteSiiModal, false)">Importación por Día</button>
										</div>
									</div>
									<button ngbTooltip="Importa boletas electrónicas afectas y exentas registradas en el SII" id="btnImportBoletasSii" class="btn btn-info float-right mr-5 mt-5" *ngIf="permissions.getPermission('40-18-42').asignado" (click)="openImportBoletasSiiModal(importBoletasSiiModal)">
										<i class="flaticon-refresh"></i>
										Importar boletas desde el SII
									</button>
									<div ngbDropdown>
										<button ngbDropdownToggle id="dropdownDtes" class="btn btn-success float-right mr-5 mt-5">
											<i class="flaticon-add-circular-button"></i>
											Generar DTE
										</button>
										<div ngbDropdownMenu aria-labelledby="dropdownDescargas">
											<button class="buttonMantenedor" ngbDropdownItem (click)="navigateToFacturador(0)" data-gtm-id="generar-factura" data-gtm-group="dte-emitidos" *ngIf="permissions.getPermission('40-18-10').asignado">Factura Individual</button>
											<button class="buttonMantenedor" ngbDropdownItem (click)="navigateToFacturador(1)" data-gtm-id="generar-boleta" data-gtm-group="dte-emitidos" *ngIf="permissions.getPermission('40-18-33').asignado">Boleta Individual</button>

											<!-- Agregamos Nota de Crédito y Nota de Débito -->
											<button class="buttonMantenedor" ngbDropdownItem (click)="abrirModalReferencia(6)" data-gtm-id="generar-nota-debito" data-gtm-group="dte-emitidos" *ngIf="permissions.getPermission('40-18-31').asignado">Nota de Débito</button>
											<button class="buttonMantenedor" ngbDropdownItem (click)="abrirModalReferencia(7)" data-gtm-id="generar-nota-credito" data-gtm-group="dte-emitidos" *ngIf="permissions.getPermission('40-18-30').asignado">Nota de Crédito</button>

											<button class="buttonMantenedor" ngbDropdownItem (click)="navigateToFacturador(5)" data-gtm-id="generar-liquidacion" data-gtm-group="dte-emitidos" *ngIf="permissions.getPermission('40-21-10').asignado">Liquidación de Factura</button>
										</div>
									</div>
								</div>
							</div>
							<div class="card-content">
								<div class="card-body">
									<!-- seccion tabla -->
									<ngx-datatable
										#table
										*ngIf="componentStarted"
										class="material mobile-hidden"
										[rows]="rowsMantenedor"
										[columnMode]="'flex'"
										[headerHeight]="50"
										[footerHeight]="50"
										[rowHeight]="70"
										fxFlex="auto"
										[perfectScrollbar]="configScroll"
										[selectionType]="'checkbox'"
										[selected]="selected"
										(selected)="onSelect($event)"
										[rowIdentity]="getId"
										[externalPaging]="true"
										[count]="page.totalElements"
										[offset]="page.pageNumber"
										[limit]="page.pageSize"
										(page)="setPage($event)"
										(sort)="utilities.onSortTable(table, page)"
										[messages]="{ emptyMessage: 'Sin datos para mostrar' | translate, totalMessage: 'Elementos totales' | translate, selectedMessage: false }"
										[externalSorting]="false"
										[sortType]="SortType.multi">
										<ngx-datatable-column [width]="40" [sortable]="false" [canAutoResize]="false" [draggable]="false" [resizeable]="false">
											<ng-template ngx-datatable-header-template let-value="value">
												<input type="checkbox" class="customCheckbox" [checked]="selectedAllItemsInPage[page.pageNumber]" (change)="selectAll($event)" />
											</ng-template>
											<ng-template ngx-datatable-cell-template let-value="value" let-isSelected="isSelected" let-onCheckboxChangeFn="onCheckboxChangeFn">
												<input type="checkbox" class="customCheckbox" [checked]="isSelected" (change)="onCheckboxChangeFn($event)" />
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="Est. pago" [width]="96" [sortable]="false" [canAutoResize]="false" [draggable]="false" *ngIf="showMarcarPagadoButton && permissions.getPermission('83-10').asignado">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span>Estado pago</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row">
												<span class="badge badge-success imported-badge font-italic" *ngIf="isFacturaOrBoleta(row.codigoTipoDte) && !row.anulado && row.dtePagado == true">Pagado</span>
												<span class="badge badge-warning imported-badge font-italic" *ngIf="isFacturaOrBoleta(row.codigoTipoDte) && !row.anulado && row.dtePagado == false">Pendiente</span>
												<span class="badge badge-danger imported-badge font-italic" *ngIf="isFacturaOrBoleta(row.codigoTipoDte) && row.anulado">Anulado</span>
												<span class="badge badge-light imported-badge font-italic" *ngIf="row.dtePagado == null && !row.anulado && (showMarcarPagadoButton || !isFacturaOrBoleta(row.codigoTipoDte))">No aplica</span>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="nombreTipoDte" [flexGrow]="1" [sortable]="true" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'" [resizeable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Tipo</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment">{{ row.nombreTipoDte }}</span>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="folio" [flexGrow]="1.6" [sortable]="true" [cellClass]="'number-table-alignment'" [headerClass]="'number-table-alignment'" [resizeable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="number-table-alignment">Folio</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="number-table-alignment">{{ row.folio }}</span></ng-template
											>
										</ngx-datatable-column>
										<ngx-datatable-column name="Cliente" [flexGrow]="2" [sortable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'" [resizeable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Cliente</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment">{{ row.rutReceptorDv ? row.rutReceptorDv : "No disponible" }}</span></ng-template
											>
										</ngx-datatable-column>
										<ngx-datatable-column name="Razón Social" [flexGrow]="4.5" [sortable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'" [resizeable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Razón Social</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row">
												<div class="text-limited">
													<span class="text-wrap">
														{{ row.razonSocial ? row.razonSocial : "No disponible" }}
													</span>
												</div>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="fecha" [flexGrow]="2" [sortable]="true" [cellClass]="'date-table-alignment'" [headerClass]="'date-table-alignment'" [resizeable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="date-table-alignment text-fecha">Fecha</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="date-table-alignment">{{ row.fecha | date : "dd/MM/yyyy" }}</span></ng-template
											>
										</ngx-datatable-column>
										<ngx-datatable-column name="total" [flexGrow]="2" [sortable]="true" [headerClass]="'number-table-alignment'" [resizeable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="number-table-alignment text-monto">Monto</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="number-table-alignment">{{ row.total | currency : "$ " : "symbol" : "1.0-0" : "es" }}</span></ng-template
											>
										</ngx-datatable-column>
										<ngx-datatable-column [cellTemplate]="semaforo" [sortable]="false" name="Estado" [flexGrow]="1.8" [resizeable]="false"></ngx-datatable-column>
										<ngx-datatable-column name="Acciones" [flexGrow]="4.5" [sortable]="false" [resizeable]="false">
											<ng-template ngx-datatable-cell-template let-row="row">
												<div ngbDropdown class="dropdownBotoneraLinea" container="body">
													<a [routerLink]="" title="Descarga Documento" ngbTooltip="Descarga Documento" class="success edit mr-1 mrless" ngbDropdownToggle id="dropdownDoc" container="body" *ngIf="(!row.importado || row.formaPago == 'Importado') && permissions.getPermission('40-18-22').asignado">
														<div class="icon-circle bg-danger text-center align-middle pt-file-button">
															<fa-icon icon="file-pdf" class="fa-lg text-white"></fa-icon>
														</div>
													</a>
													<div ngbDropdownMenu aria-labelledby="dropdownDoc">
														<button class="buttonOption" data-gtm-group="dte-emitidos" id="pdf" ngbDropdownItem (click)="downloadPDF(row)" *ngIf="(!row.importado || row.formaPago == 'Importado') && permissions.getPermission('40-18-22').asignado">Descarga PDF</button>
														<button class="buttonOption" data-gtm-group="dte-emitidos" id="cedible" ngbDropdownItem (click)="downloadPDFCedible(row, true)" *ngIf="(!row.importado || row.formaPago == 'Importado') && permissions.getPermission('40-18-23').asignado && row.cedibleHabilitado">Descarga PDF Cedible</button>
														<button class="buttonOption" data-gtm-group="dte-emitidos" id="xml" ngbDropdownItem (click)="downloadXml(row)" *ngIf="(!row.importado || row.formaPago == 'Importado') && permissions.getPermission('40-18-24').asignado">Descargar XML</button>
														<button class="buttonOption" data-gtm-group="dte-emitidos" id="masivo" ngbDropdownItem (click)="downloadMassiveFile(row)" *ngIf="(!row.importado || row.formaPago == 'Importado') && permissions.getPermission('40-10-12').asignado && row.importacionMasivaId != null">Descargar Archivo Importación Masiva</button>
													</div>
												</div>
												<a [routerLink]="" ngbTooltip="Trazabilidad" class="buttonOption primary edit mr-1 mrless" data-gtm-group="dte-emitidos" id="trazabilidad" (click)="openTraceShowModal(dteTracesModal, row)" *ngIf="permissions.getPermission('40-18-26').asignado">
													<div class="icon-circle bg-info text-center align-middle pt-list-button">
														<fa-icon icon="list-alt" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<a [routerLink]="" ngbTooltip="Detalles" class="buttonOption primary edit mr-1 mrless" data-gtm-group="dte-emitidos" id="detalles" (click)="detailOpenModal(dteDetailModal, row)" *ngIf="permissions.getPermission('40-18-28').asignado">
													<div class="icon-circle bg-warning text-center align-middle pt-info-button">
														<fa-icon icon="info-circle" class="fa-lg text-white"></fa-icon>
													</div>
												</a>

												<div ngbDropdown class="dropdownBotoneraLinea" container="body">
													<a *ngIf="!row.anulado && (!row.importado || row.formaPago == 'Importado') && (permissions.getPermission('40-18-30').asignado || permissions.getPermission('40-18-31').asignado) && (row.notaCreditoHabilitada || row.notaDebitoHabilitada) && row.codigoTipoDte != 46" [routerLink]="" container="body" ngbTooltip="Generar Nota" class="danger edit mr-1 mrless" ngbDropdownToggle id="dropdownNotas">
														<div class="icon-circle bg-danger text-center align-middle pt-null-button">
															<fa-icon icon="file-alt" class="fa-lg text-white"></fa-icon>
														</div>
													</a>
													<div ngbDropdownMenu aria-labelledby="dropdownNotas">
														<button class="buttonOption" data-gtm-group="dte-emitidos" id="genera_nota_credito" ngbDropdownItem name="genera_nota_credito" (click)="openAnularDteModal(anularNCDteModal, row)" *ngIf="(!row.importado || row.formaPago == 'Importado') && permissions.getPermission('40-18-30').asignado && row.codigoTipoDte == 46">Generar Nota Credito</button>

														<button class="buttonOption" data-gtm-group="dte-emitidos" id="genera_nota_credito" ngbDropdownItem name="genera_nota_credito" (click)="openAnularDteModal(anularNCDteModal, row)" *ngIf="(!row.importado || row.formaPago == 'Importado') && permissions.getPermission('40-18-30').asignado && row.notaCreditoHabilitada && row.codigoTipoDte != 46">Generar Nota Credito</button>
														<button class="buttonOption" data-gtm-group="dte-emitidos" id="genera_nota_debito" ngbDropdownItem name="genera_nota_debito" (click)="openAnularDteModal(anularNDDteModal, row)" *ngIf="(!row.importado || row.formaPago == 'Importado') && permissions.getPermission('40-18-31').asignado && row.codigoTipoDte == 61">Generar Nota Debito</button>
														<button class="buttonOption" data-gtm-group="dte-emitidos" id="genera_nota_debito" ngbDropdownItem name="genera_nota_debito" (click)="openAnularDteModal(anularNDInterestsDTEModal, row)" *ngIf="(!row.importado || row.formaPago == 'Importado') && permissions.getPermission('40-18-31').asignado && row.notaDebitoHabilitada && row.codigoTipoDte != 61 && row.codigoTipoDte != 39">Generar Nota Debito</button>
													</div>
												</div>
												<a [routerLink]="" ngbTooltip="Reenviar Documento al SII" class="buttonOption primary edit mr-1 mrless" data-gtm-group="dte-emitidos" id="reenviar_al_SII" (click)="resendDte(row)" *ngIf="!row.importado && permissions.getPermission('40-18-38').asignado && row.estadoSii == 8 && !row.folioReutilizado">
													<div class="icon-circle bg-info text-center align-middle pt-info-button">
														<fa-icon icon="recycle" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<div ngbDropdown class="dropdownBotoneraLinea" container="body" *ngIf="!row.importado || row.formaPago == 'Importado'">
													<a container="body" ngbTooltip="Opciones" class="primary edit mr-1 mrless" ngbDropdownToggle id="dropdownOpciones">
														<div class="icon-circle bg-success text-center align-middle pt-null-button">
															<fa-icon icon="cog" class="fa-lg text-white"></fa-icon>
															<!-- <i class="fa-lg fa-sharp-duotone fa-solid fa-gear" style="color:blue"></i> -->
														</div>
													</a>
													<div ngbDropdownMenu aria-labelledby="dropdownOpciones">
														<span
															[ngbTooltip]="!(row.estadoSii == 6 || row.estadoSii == 7)? 'Esta opción solo estará disponible cuando el documento esté aceptado o aceptado con reparos en el SII.': null"
															[container]="'body'"
															>
															<button class="buttonOption" data-gtm-group="dte-emitidos" id="enviar-email" (click)="openDocumentSenderModal(dteSenderModal, row)" ngbDropdownItem name="enviar_email" *ngIf="permissions.getPermission('40-18-20').asignado && !row.folioReutilizado"[disabled]="!(row.estadoSii == 6 || row.estadoSii == 7)" >
																Enviar Email
															</button>
														</span>
														<button class="buttonOption" data-gtm-group="dte-emitidos" id="ceder" (click)="openCesionDte(cesionDteModal, row)" ngbDropdownItem name="enviar_email" *ngIf="row.cesionHabilitada && permissions.getPermission('40-18-36').asignado && row.codigoTipoDte == 33 && !row.cedidoCompleto">Ceder Factura</button>
														<button class="buttonOption" data-gtm-group="dte-emitidos" id="liquidacion-negativa" (click)="negativeSettlement(row)" ngbDropdownItem name="enviar_email" *ngIf="permissions.getPermission('40-21-10').asignado && row.codigoTipoDte == 43 && !row.negativa && !row.anulado && (row.estadoSii == 6 || row.estadoSii == 7)">Generar Liquidación Negativa</button>
														<button class="buttonOption" data-gtm-group="dte-emitidos" id="reenviar-email-validacion" (click)="resendEmailSii(row)" ngbDropdownItem name="enviar_email" *ngIf="permissions.getPermission('40-18-39').asignado && (row.estadoSii == 5 || row.estadoSii == 7) && row.codigoTipoDte != 39 && row.codigoTipoDte != 41 && !row.folioReutilizado">Solicitar Mail Validación</button>
														<button class="buttonOption" data-gtm-group="dte-emitidos" id="reutilizar-folio" (click)="reuse(row)" ngbDropdownItem name="enviar_email" *ngIf="!row.folioReutilizado && permissions.getPermission('40-18-44').asignado && row.reutilizarFoliohabilitado">Reutilizar Folio</button>
														<button class="buttonOption" data-gtm-group="dte-emitidos" id="copiar" (click)="copiar(row)" ngbDropdownItem name="enviar_email" *ngIf="!row.folioReutilizado">Copiar DTE</button>
														<button class="buttonOption" data-gtm-group="dte-emitidos" id="regenerar" (click)="regenerarPDF(row)" ngbDropdownItem name="enviar_email" *ngIf="!row.folioReutilizado">Regenerar PDF</button>
													</div>
												</div>
												<!--opciones para marcar como pagado/pendiente y reenviar link/QR de pago payku-->
												<div ngbDropdown class="dropdownBotoneraLinea" container="body" *ngIf="isFacturaOrBoleta(row.codigoTipoDte) && showMarcarPagadoButton && row.dtePagado !== null && !row.anulado && (!row.importado || row.formaPago == 'Importado') && (permisoPayku || permissions.getPermission('83-12').asignado)">
													<a container="body" ngbTooltip="Opciones payku" class="primary edit mr-1 mrless" ngbDropdownToggle id="dropdownOpciones">
														<div class="icon-circle bg-payku text-center align-middle pt-null-button">
															<img src="assets/deployAssets/logo_payku.png" alt="Payku" class="payku-icon" />
														</div>
													</a>
													<div ngbDropdownMenu aria-labelledby="dropdownOpciones">
														<button class="buttonOption" data-gtm-group="dte-emitidos" id="marcar-como-pagado" ngbDropdownItem *ngIf="permisoPayku && row.dtePagado === false" (click)="confirmarCambioEstado(row, 'pagado')">Marcar como Pagado</button>
														<button class="buttonOption" data-gtm-group="dte-emitidos" id="marcar-como-pendiente" ngbDropdownItem *ngIf="permisoPayku && row.dtePagado === true" (click)="confirmarCambioEstado(row, 'pendiente')">Marcar como Pendiente</button>
														<button class="buttonOption" data-gtm-group="dte-emitidos" id="reenviar-link-payku" ngbDropdownItem *ngIf="permissions.getPermission('83-12').asignado && row.dtePagado == false && !row.anulado && !row.folioReutilizado" (click)="reenviarLinkPago(row)">Reenviar link/QR de pago payku</button>
													</div>
												</div>
												<span class="badge badge-danger imported-badge font-italic" *ngIf="row.anulado && !(tienePayku && isFacturaOrBoleta(row.codigoTipoDte))">Nula</span>

												<span class="badge badge-light imported-badge font-italic" *ngIf="row.folioReutilizado">Folio reutilizado</span>
												<span class="badge badge-light imported-badge font-italic" *ngIf="row.importado && row.formaPago != 'Importado'">Importado SII</span>
												<span class="badge badge-light imported-badge font-italic" *ngIf="row.importado && row.formaPago == 'Importado'">Importado Sistema</span>
											</ng-template>
										</ngx-datatable-column>

										<ngx-datatable-footer>
											<ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset" let-isVisible="isVisible">
												<div class="col-auto">Elementos por página</div>
												<div class="mr-5">
													<ng-select [(ngModel)]="page.pageSize" [items]="page.pageSizes" [clearable]="false" (change)="setPageSize()" dropdownPosition="top" style="overflow: visible" appendTo="datatable-footer">
														<option *ngFor="let option of page.pageSizes" [value]="option"></option>
													</ng-select>
												</div>
												<div class="ml-5 col-auto divisor-footer">
													<div class="page-count">{{ rowCount | number:'1.0-0':'es-CL' }} Elementos totales</div>
												</div>
												<datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'" [pagerRightArrowIcon]="'datatable-icon-right'" [pagerPreviousIcon]="'datatable-icon-prev'" [pagerNextIcon]="'datatable-icon-skip'" [page]="curPage" [size]="pageSize" [count]="rowCount" [hidden]="!(rowCount / pageSize > 1)" (change)="table.onFooterPage($event)"> </datatable-pager>
											</ng-template>
										</ngx-datatable-footer>
									</ngx-datatable>

									<!-- fin seccion tabla seccion tabla -->

									<!-- tabla movil -->
									<ngx-datatable
										#tableMobile
										*ngIf="componentStarted"
										class="material desktop-hidden"
										[rows]="rowsMantenedor"
										[columnMode]="'flex'"
										[headerHeight]="50"
										[footerHeight]="70"
										[rowHeight]="70"
										fxFlex="auto"
										[perfectScrollbar]="configScroll"
										[selectionType]="'checkbox'"
										[selected]="selected"
										(selected)="onSelect($event)"
										[rowIdentity]="getId"
										[externalPaging]="true"
										[count]="page.totalElements"
										[offset]="page.pageNumber"
										[limit]="page.pageSize"
										[scrollbarH]="true"
										(page)="setPage($event)"
										[messages]="{ emptyMessage: 'Sin datos para mostrar' | translate, totalMessage: 'Elementos totales' | translate, selectedMessage: false }">
										<!-- Row Detail Template -->
										<ngx-datatable-row-detail [rowHeight]="70" #myDetailRow>
											<ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
												<div class="text-wrap">{{ row.nombreTipoDte }} n° {{ row.folio }} {{ row.razonSocial ? ", Receptor: " + row.razonSocial : "" }}, Total: {{ row.total | currency : "$ " : "symbol" : "1.0-0" : "es" }} Fecha: {{ row.fecha | date : "dd/MM/yyyy" }}</div>
											</ng-template>
										</ngx-datatable-row-detail>

										<ngx-datatable-column [width]="30" [resizeable]="false" [sortable]="false" [draggable]="false" [canAutoResize]="false">
											<ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
												<a [class.datatable-icon-right]="!expanded" [class.datatable-icon-down]="expanded" title="Expand/Collapse Row" (click)="toggleExpandRow(row)" class="desktop-hidden"> </a>
											</ng-template>
										</ngx-datatable-column>

										<ngx-datatable-column name="Razón Social" [flexGrow]="4" [sortable]="false" [resizeable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Documento</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment"> {{ row.nombreTipoDte }} | {{ row.folio }}</span>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column [cellTemplate]="semaforo" [sortable]="false" name="Estado" [flexGrow]="4" [resizeable]="false"></ngx-datatable-column>
										<ngx-datatable-column name="Acciones" [flexGrow]="3" [sortable]="false" [resizeable]="false">
											<ng-template ngx-datatable-cell-template let-row="row">
												<div class="action-container">
													<div class="main-action-button" (click)="toggleActions(row)" *ngIf="!row.showActions">
														<fa-icon [icon]="row.showActions ? 'minus' : 'list'"></fa-icon>
													</div>

													<div class="action-buttons action-buttons-client" [ngClass]="{ show: row.showActions }">
														<a [routerLink]="" ngbTooltip="Enviar correo" class="primary edit mr-1 mrless" id="mantenedor-dte-emitidos.Enviar_correo" (click)="openDocumentSenderModal(dteSenderModal, row)" *ngIf="!row.importado && permissions.getPermission('40-18-20').asignado">
															<div class="icon-circle bg-success text-center align-middle pt-email-button">
																<fa-icon icon="envelope" class="fa-lg text-white"></fa-icon>
															</div>
														</a>
														<div ngbDropdown class="dropdownBotoneraLinea" container="body">
															<a [routerLink]="" title="Descarga Documento" ngbTooltip="Descarga Documento" class="success edit mr-1 mrless" ngbDropdownToggle id="mantenedor-dte-emitidos.dropdownTipoDoc" container="body" *ngIf="!row.importado && permissions.getPermission('40-18-22').asignado">
																<div class="icon-circle bg-danger text-center align-middle pt-file-button">
																	<fa-icon icon="file-pdf" class="fa-lg text-white"></fa-icon>
																</div>
															</a>

															<div ngbDropdownMenu aria-labelledby="dropdownDoc">
																<button ngbDropdownItem (click)="downloadPDF(row)" id="mantenedor-dte-emitidos.pdf" *ngIf="!row.importado && permissions.getPermission('40-18-22').asignado">Descarga PDF</button>
																<button ngbDropdownItem (click)="downloadPDFCedible(row, true)" id="mantenedor-dte-emitidos.pdfcedible" *ngIf="!row.importado && permissions.getPermission('40-18-23').asignado && row.cedibleHabilitado">Descarga PDF Cedible</button>
																<button ngbDropdownItem (click)="downloadXml(row)" id="mantenedor-dte-emitidos.xml" *ngIf="!row.importado && permissions.getPermission('40-18-24').asignado">Descargar XML</button>
															</div>
														</div>
														<a [routerLink]="" ngbTooltip="Trazabilidad" class="primary edit mr-1 mrless" id="mantenedor-dte-emitidos.Trazabilidad" (click)="openTraceShowModal(dteTracesModal, row)" *ngIf="permissions.getPermission('40-18-26').asignado">
															<div class="icon-circle bg-info text-center align-middle pt-list-button">
																<fa-icon icon="list-alt" class="fa-lg text-white"></fa-icon>
															</div>
														</a>
														<a [routerLink]="" ngbTooltip="Detalles" class="primary edit mr-1 mrless" id="mantenedor-dte-emitidos.Detalles" (click)="detailOpenModal(dteDetailModal, row)" *ngIf="permissions.getPermission('40-18-28').asignado">
															<div class="icon-circle bg-warning text-center align-middle pt-info-button">
																<fa-icon icon="info-circle" class="fa-lg text-white"></fa-icon>
															</div>
														</a>
														<div ngbDropdown class="dropdownBotoneraLinea" container="body">
															<a *ngIf="!row.anulado && (!row.importado || row.formaPago == 'Importado') && (permissions.getPermission('40-18-30').asignado || permissions.getPermission('40-18-31').asignado) && (row.notaCreditoHabilitada || row.notaDebitoHabilitada) && row.codigoTipoDte != 46" [routerLink]="" container="body" ngbTooltip="Generar Nota" class="danger edit mr-1 mrless" ngbDropdownToggle id="dropdownNotas">
																<div class="icon-circle bg-danger text-center align-middle pt-null-button">
																	<fa-icon icon="file-alt" class="fa-lg text-white"></fa-icon>
																</div>
															</a>
															<div ngbDropdownMenu aria-labelledby="dropdownNotas">
																<button ngbDropdownItem name="genera_nota_credito" (click)="openAnularDteModal(anularNCDteModal, row)" *ngIf="(!row.importado || row.formaPago == 'Importado') && permissions.getPermission('40-18-30').asignado && row.codigoTipoDte == 46">Generar Nota Credito</button>
																<button ngbDropdownItem name="genera_nota_credito" (click)="openAnularDteModal(anularNCDteModal, row)" *ngIf="(!row.importado || row.formaPago == 'Importado') && permissions.getPermission('40-18-30').asignado && row.notaCreditoHabilitada && row.codigoTipoDte != 46">Generar Nota Credito</button>
																<button ngbDropdownItem name="genera_nota_debito" (click)="openAnularDteModal(anularNDDteModal, row)" *ngIf="(!row.importado || row.formaPago == 'Importado') && permissions.getPermission('40-18-31').asignado && row.codigoTipoDte == 61">Generar Nota Debito</button>
																<button ngbDropdownItem name="genera_nota_debito" (click)="openAnularDteModal(anularNDInterestsDTEModal, row)" *ngIf="(!row.importado || row.formaPago == 'Importado') && permissions.getPermission('40-18-31').asignado && row.notaDebitoHabilitada && row.codigoTipoDte != 61 && row.codigoTipoDte != 39">Generar Nota Debito</button>
															</div>
														</div>
													</div>
												</div>
											</ng-template>
										</ngx-datatable-column>

										<ngx-datatable-footer>
											<ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset" let-isVisible="isVisible">
												<div class="row" style="width: 100%">
													<div class="col-12 mb-2 ml-3 text-center mt-2">
														<datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'" [pagerRightArrowIcon]="'datatable-icon-right'" [pagerPreviousIcon]="'datatable-icon-prev'" [pagerNextIcon]="'datatable-icon-skip'" [page]="curPage" [size]="pageSize" [count]="rowCount" [hidden]="!(rowCount / pageSize > 1)" (change)="tableMobile.onFooterPage($event)"> </datatable-pager>
													</div>
													<div class="col-12 d-flex justify-content-center">
														<span class="mr-2 mt-3">Elementos por página</span>

														<ng-select [(ngModel)]="page.pageSize" [items]="page.pageSizes" [clearable]="false" (change)="setPageSize()" dropdownPosition="top" style="overflow: visible" appendTo="body">
															<option *ngFor="let option of page.pageSizes" [value]="option"></option>
														</ng-select>
														<span class="ml-4 mt-3"> Página {{ curPage }} de {{ getTotalPages(rowCount, pageSize) }} </span>
													</div>
												</div>
											</ng-template>
										</ngx-datatable-footer>
									</ngx-datatable>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
		</div>
	</div>
</div>

<ng-template #semaforo let-row="row">
	<app-semaforo-estado-dte [row]="row"></app-semaforo-estado-dte>
</ng-template>

<ng-template #dteDetailModal let-d="dismiss" id="detail-modal">
	<div class="modal-content">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Detalle de {{ dteToShow.nombreTipoDte }} - N° {{ dteToShow.folio }}</div>
				<div class="modal-wizard-desc">Detalles del documento seleccionado</div>
			</div>
		</div>
		<div class="modal-body">
			<div *ngIf="dteToShow.codigoTipoDte == 46" class="row form-group mx-auto" id="details-client">
				<h4>Datos del Proveedor</h4>
				<div class="col-12">
					<div class="row">
						<div class="col-4">
							<span class="d-block">Rut</span>
							<span class="d-block">Razon Social</span>
							<span class="d-block">Giro</span>
							<span class="d-block">Comuna</span>
							<span class="d-block">Ciudad</span>
							<span class="d-block">Dirección</span>
							<span class="d-block">Email</span>
							<span class="d-block">Fecha Emisión</span>
						</div>
						<div class="col-8">
							<span class="d-block text-right">{{
								dteToShow.proveedor.rut
									? dteToShow.proveedor.rut + "-" + dteToShow.proveedor.dv
									: "No
								disponible"
							}}</span>
							<span class="d-block text-right">{{
								dteToShow.proveedor.razonSocial
									? dteToShow.proveedor.razonSocial
									: "No
								disponible"
							}}</span>
							<span class="d-block text-right">{{
								dteToShow.proveedor.giro
									? dteToShow.proveedor.giro
									: "No
								disponible"
							}}</span>
							<span class="d-block text-right">{{
								dteToShow.proveedor.comuna
									? dteToShow.proveedor.comuna
									: "No
								disponible"
							}}</span>
							<span class="d-block text-right">{{
								dteToShow.proveedor.ciudad
									? dteToShow.proveedor.ciudad
									: "No
								disponible"
							}}</span>
							<span class="d-block text-right">{{
								dteToShow.proveedor.dirFact
									? dteToShow.proveedor.dirFact
									: "No
								disponible"
							}}</span>
							<span class="d-block text-right">{{
								dteToShow.proveedor.correoPar
									? dteToShow.proveedor.correoPar
									: "No
								disponible"
							}}</span>
							<span class="d-block text-right">{{ dteToShow.fecha | date : "dd/MM/yyyy HH:mm" }}</span>
						</div>
					</div>
				</div>
			</div>
			<div *ngIf="dteToShow.codigoTipoDte != 46" class="row form-group mx-auto" id="details-client">
				<h4>Datos del Cliente</h4>
				<div class="col-12">
					<div class="row">
						<table class="detail-table">
							<tr>
								<td>Rut</td>
								<td>
									{{
										dteToShow.rutReceptorDv
											? dteToShow.rutReceptorDv
											: dteToShow.receptorAsociado.rutString
											? dteToShow.receptorAsociado.rutString
											: "No
									Disponible"
									}}
								</td>
							</tr>
							<tr>
								<td>Razón Social</td>
								<td>{{ dteToShow.razonSocial ? dteToShow.razonSocial : dteToShow.receptorAsociado.razonSocial ? dteToShow.receptorAsociado.razonSocial : "No disponible" }}</td>
							</tr>
							<tr>
								<td>Giro</td>
								<td>
									{{
										dteToShow.receptorAsociado.giro
											? dteToShow.receptorAsociado.giro
											: "No
									disponible"
									}}
								</td>
							</tr>
							<tr>
								<td>Comuna</td>
								<td>
									{{
										dteToShow.receptorAsociado.comuna
											? dteToShow.receptorAsociado.comuna
											: "No
									disponible"
									}}
								</td>
							</tr>
							<tr>
								<td>Ciudad</td>
								<td>
									{{
										dteToShow.receptorAsociado.ciudad
											? dteToShow.receptorAsociado.ciudad
											: "No
									disponible"
									}}
								</td>
							</tr>
							<tr>
								<td>Dirección</td>
								<td>
									{{
										dteToShow.receptorAsociado.dirFact
											? dteToShow.receptorAsociado.dirFact
											: "No
									disponible"
									}}
								</td>
							</tr>
							<tr>
								<td>Email</td>
								<td>
									{{
										dteToShow.receptorAsociado.correoFact
											? dteToShow.receptorAsociado.correoFact
											: "No
									disponible"
									}}
								</td>
							</tr>
							<tr>
								<td>Fecha Emisión</td>
								<td>{{ dteToShow.fecha | date : "dd/MM/yyyy" }}</td>
							</tr>
							<tr *ngIf="dteToShow.fechaVencimiento">
								<td>Fecha Vencimiento</td>
								<td>{{ dteToShow.fechaVencimiento | date : "dd/MM/yyyy" }}</td>
							</tr>
							<tr *ngIf="dteToShow.estadoAcuse">
								<td>Estado Acuse</td>
								<td>{{ dteToShow.descripcionEstadoAcuse }}</td>
							</tr>
						</table>
					</div>
				</div>
			</div>
			<hr />
			<div class="row form-group mx-auto" *ngIf="dteToShow.listaReferencias && dteToShow.listaReferencias.length > 0">
				<h4>Referencias</h4>
				<div class="col-12">
					<!-- listado detalle referencias -->
					<div class="row">
						<div class="col-4">
							<span class="d-block">Fecha</span>
							<span class="d-block">Glosa</span>
						</div>
						<div class="col-8">
							<span class="d-block text-right">{{ dteToShow.listaReferencias[0].fecha | date : "dd/MM/yyyy HH:mm" }}</span>
							<span class="d-block text-right">{{ dteToShow.listaReferencias[0].glosa }}</span>
						</div>
					</div>
					<div class="row" *ngIf="dteToShow.listaReferencias[0].dte"></div>
				</div>
				<hr />
			</div>
			<div class="row form-group mx-auto" *ngIf="!dteToShow.importado">
				<h4>Detalles</h4>
				<div class="col-12">
					<div class="row" id="details-dte">
						<ng-container *ngFor="let detalle of dteToShow.detalleDte" class="col-12">
							<div class="col-9">
								<p>{{ detalle.cantidad }} * {{ detalle.nombre }}</p>
							</div>
							<div class="col-3">
								<p class="text-right">
									{{ detalle.total | currency : "$ " : "symbol" : "1.0-0" : "es" }}
								</p>
							</div>
						</ng-container>
					</div>
					<hr />
				</div>
			</div>
			<div class="row form-group mx-auto" *ngIf="dteToShow.codigoTipoDte == 43">
				<h4>Comisiones y Otros Cargos</h4>
				<div class="col-12">
					<div class="row" id="details-dte">
						<ng-container *ngFor="let detalle of dteToShow.comisionesCargosDte" class="col-12">
							<div class="col-9">
								<p>
									{{ detalle.glosa }}
								</p>
							</div>
							<div class="col-3">
								<p class="text-right">
									{{ detalle.total | currency : "$ " : "symbol" : "1.0-0" : "es" }}
								</p>
							</div>
						</ng-container>
					</div>
					<hr />
				</div>
			</div>
			<div class="row form-group mx-auto d-flex justify-content-between">
				<div class="col-4" *ngIf="dteToShow.observaciones">
					<div class="row" id="details-observaciones">
						<div class="col-12">
							<h4 style="margin-left: -15px">Observaciones</h4>
							<p>{{ dteToShow.observaciones ? dteToShow.observaciones : "" }}</p>
						</div>
					</div>
				</div>
				<div [ngClass]="{ 'col-8': dteToShow.observaciones, 'col-12': !dteToShow.observaciones }">
					<div class="row" id="details-total-dte">
						<div class="offset-4 col-5" *ngIf="dteToShow.descuentoGlobal > 0">
							<p class="text-right font-weight-bold">Descuento Global ( - )</p>
						</div>
						<div class="col-3" *ngIf="dteToShow.descuentoGlobal > 0">
							<p class="text-right font-weight-bold">
								{{ dteToShow.descuentoGlobal | currency : "$ " : "symbol" : "1.0-0" : "es" }}
							</p>
						</div>
						<div class="offset-6 col-3">
							<p class="text-right font-weight-bold">Neto</p>
						</div>
						<div class="col-3">
							<p class="text-right font-weight-bold">
								{{ dteToShow.neto | currency : "$ " : "symbol" : "1.0-0" : "es" }}
							</p>
						</div>
						<div class="offset-6 col-3">
							<p class="text-right font-weight-bold">Iva</p>
						</div>
						<div class="col-3">
							<p class="text-right font-weight-bold">
								{{ dteToShow.iva | currency : "$ " : "symbol" : "1.0-0" : "es" }}
							</p>
						</div>
						<div class="offset-6 col-3" *ngIf="dteToShow.tieneIvaTerceros && dteToShow.ivaTerceros > 0">
							<p class="text-right font-weight-bold">Iva Terceros</p>
						</div>
						<div class="col-3" *ngIf="dteToShow.tieneIvaTerceros && dteToShow.ivaTerceros > 0">
							<p class="text-right font-weight-bold">
								{{ dteToShow.ivaTerceros | currency : "$ " : "symbol" : "1.0-0" : "es" }}
							</p>
						</div>
						<div class="offset-6 col-3" *ngIf="dteToShow.tieneIvaTerceros && dteToShow.ivaPropio > 0">
							<p class="text-right font-weight-bold">Iva Propio</p>
						</div>
						<div class="col-3" *ngIf="dteToShow.tieneIvaTerceros && dteToShow.ivaPropio > 0">
							<p class="text-right font-weight-bold">
								{{ dteToShow.ivaPropio | currency : "$ " : "symbol" : "1.0-0" : "es" }}
							</p>
						</div>
						<div class="offset-4 col-5" *ngIf="dteToShow.impuestos > 0">
							<p class="text-right font-weight-bold">Impuestos Adicionales</p>
						</div>
						<div class="col-3" *ngIf="dteToShow.impuestos > 0">
							<p class="text-right font-weight-bold">
								{{ dteToShow.impuestos | currency : "$ " : "symbol" : "1.0-0" : "es" }}
							</p>
						</div>

						<div class="offset-6 col-3">
							<p class="text-right font-weight-bold">Exento</p>
						</div>
						<div class="col-3">
							<p class="text-right font-weight-bold">
								{{ dteToShow.exento | currency : "$ " : "symbol" : "1.0-0" : "es" }}
							</p>
						</div>
						<div class="offset-6 col-3" *ngIf="dteToShow.codigoTipoDte == 43">
							<p class="text-right font-weight-bold">Comisiones y Cargos</p>
						</div>
						<div class="col-3" *ngIf="dteToShow.codigoTipoDte == 43">
							<p class="text-right font-weight-bold">
								{{ dteToShow.comisionCargo | currency : "$ " : "symbol" : "1.0-0" : "es" }}
							</p>
						</div>
						<div class="offset-6 col-3">
							<p class="text-right font-weight-bold">Total</p>
						</div>
						<div class="col-3">
							<p class="text-right font-weight-bold">
								{{ dteToShow.total | currency : "$ " : "symbol" : "1.0-0" : "es" }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-success" data-dismiss="modal" (click)="d('Cross click')">Volver</button>
		</div>
	</div>
</ng-template>

<ng-template #dteTracesModal let-d="dismiss">
	<div class="modal-content">
		<div class="modal-header">
			<h5 class="modal-title" id="exampleModalLabel1">Trazabilidad</h5>
		</div>
		<form #TrazaForm="ngForm">
			<div class="modal-body">
				<div class="form-group row mx-auto" style="align-items: baseline">
					<label class="col-3 label-control" for="projectinput1">Documento:</label>
					<div class="col-9">
						<input type="text" value="{{ dteToShow.nombreTipoDte }} N° {{ dteToShow.folio }}" disabled name="ngModel" class="form-control" id="fecha" />
					</div>
				</div>
				<div class="form-group row mx-auto" style="align-items: baseline">
					<table class="table table-bordered" [hidden]="tracesToShow.length == 0">
						<thead>
							<tr>
								<th>Fecha</th>
								<th>Descripción</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let traza of tracesToShow">
								<td>
									{{ traza.fecha | date : "dd/MM/yyyy HH:mm" }}
								</td>
								<td style="overflow-wrap: anywhere">
                                    {{ traza.descripcion }}
                                    <small *ngIf="traza.estadoNotificacion" class="d-block text-muted">
                                        Aviso: {{ traza.estadoNotificacion }}<span *ngIf="traza.fechaIntentoNotificacion"> · {{ traza.fechaIntentoNotificacion | date : "dd/MM/yyyy HH:mm" }}</span>
                                    </small>
                                </td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div *ngIf="mostrarMsgSii" class="text-alertSii">
				<a href="https://www.youtube.com/watch?v=vt_Bz2Jsst8" target="_blank" rel="noopener noreferrer"> Configure el SII para obtener detalles del estado de este documento. </a>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-success" data-dismiss="modal" (click)="d('Cross click')">Volver</button>
			</div>
		</form>
	</div>
</ng-template>

<ng-template #dteSenderModal let-d="dismiss" let-c="close">
	<form [formGroup]="senderForm" (ngSubmit)="onSubmitSenderForm()" #senderFormRef="ngForm">
		<div class="modal-lg">
			<div class="modal-header">
				<div class="modal-wizard-label">
					<div class="modal-wizard-title">
						<span *ngIf="selectedItem">Envío de documento por Correo</span>
						<span *ngIf="!selectedItem && selected.length > 0">Envío Masivo de Documentos por Correo</span>
						<span *ngIf="!selectedItem && selected.length === 0">Envío de documentos por Correo</span>
					</div>
					<div class="modal-wizard-desc">
						<span *ngIf="selectedItem">Indique correo y seleccione los documentos a enviar</span>
						<span *ngIf="!selectedItem && selected.length > 0">Se enviarán {{ selected.length }} DTEs al correo indicado</span>
						<span *ngIf="!selectedItem && selected.length === 0">Indique correo y seleccione los documentos a enviar</span>
					</div>
				</div>
				<!-- <h5 class="modal-title" id="titleModalSender"></h5> -->
				<button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body" *ngIf="selected.length > 0 && selectedItem == undefined">
				<div class="d-flex justify-content-between align-items-center mb-3">
					<h6 class="mb-0">Documentos seleccionados ({{ selected.length }} total)</h6>
					<span class="text-muted">Página {{ modalCurrentPage }} de {{ modalTotalPages }}</span>
				</div>
				<table class="table table-striped">
					<thead>
						<tr>
							<th>Folio</th>
							<th>Cliente</th>
							<th>Monto</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let dte of modalPaginatedItems">
							<td>{{ dte.folio }}</td>
							<td>{{ dte.razonSocial }}</td>
							<td>{{ dte.total | currency : "$ " : "symbol" : "1.0-0" : "es" }}</td>
						</tr>
					</tbody>
				</table>

				<!-- Paginador -->
				<nav aria-label="Paginación de documentos" *ngIf="modalTotalPages > 1">
					<ul class="pagination pagination-sm justify-content-center mb-0">
						<li class="page-item" [class.disabled]="modalCurrentPage === 1">
							<button type="button" class="page-link" (click)="modalPrevPage()" [disabled]="modalCurrentPage === 1"><i class="la la-angle-left"></i> Anterior</button>
						</li>

						<li class="page-item" *ngFor="let page of [].constructor(modalTotalPages); let i = index" [class.active]="modalCurrentPage === i + 1">
							<button type="button" class="page-link" (click)="modalGoToPage(i + 1)">
								{{ i + 1 }}
							</button>
						</li>

						<li class="page-item" [class.disabled]="modalCurrentPage === modalTotalPages">
							<button type="button" class="page-link" (click)="modalNextPage()" [disabled]="modalCurrentPage === modalTotalPages">Siguiente <i class="la la-angle-right"></i></button>
						</li>
					</ul>
				</nav>
			</div>
			<div class="modal-body" *ngIf="selectedItem != undefined">
				<table class="table">
					<tr>
						<th>Folio</th>
						<th>Cliente</th>
						<th>Monto</th>
					</tr>
					<tr>
						<td>{{ selectedItem.folio }}</td>
						<td>{{ selectedItem.razonSocial }}</td>
						<td>{{ selectedItem.total | currency : "$ " : "symbol" : "1.0-0" : "es" }}</td>
					</tr>
				</table>
			</div>
			<div class="modal-body">
				<div class="form-group row mx-auto">
					<label for="email" class="col-3 label-control">Dirección de Correo</label>
					<div class="col-9">
						<input
							type="email"
							name="email"
							class="form-control"
							formControlName="receiverEmail"
							autocomplete="off"
							[ngClass]="{
								'is-invalid': (senderFormRef.submitted && senderForm.controls['receiverEmail'].invalid) || (senderForm.controls['receiverEmail'].touched && senderForm.controls['receiverEmail'].invalid)
							}" />
						<div class="invalid-feedback" *ngIf="senderFormRef.submitted && (senderForm.controls['receiverEmail'].invalid || senderForm.controls['receiverEmail'].touched || senderForm.controls['receiverEmail'].dirty)">
							<div *ngIf="senderForm.get('receiverEmail').errors?.required">Campo Obligatorio</div>
							<!-- <div *ngIf="senderForm.get('receiverEmail').errors?.email||senderForm.get('receiverEmail').errors?.pattern">Ingrese un email válido</div> -->
							<div *ngIf="senderForm.get('receiverEmail').hasError('toAddress')">Ingrese un email válido</div>
							<div *ngIf="senderForm.get('receiverEmail').errors?.maxlength">Ingrese menos de 320 carácteres</div>
						</div>
					</div>
				</div>
				<div class="form-group row mx-auto">
					<label for="ccEmail" class="col-3 label-control">CC</label>
					<div class="col-9">
						<input
							type="email"
							name="ccEmail"
							class="form-control"
							formControlName="ccEmail"
							autocomplete="new-password"
							[ngClass]="{
								'is-invalid': (senderFormRef.submitted && senderForm.controls['ccEmail'].invalid) || (senderForm.controls['ccEmail'].touched && senderForm.controls['ccEmail'].invalid)
							}" />
						<div class="invalid-feedback" *ngIf="senderFormRef.submitted && (senderForm.controls['ccEmail'].invalid || senderForm.controls['ccEmail'].touched || senderForm.controls['ccEmail'].dirty)">
							<div *ngIf="senderForm.get('ccEmail').errors?.required">Campo Obligatorio</div>
							<!-- <div *ngIf="senderForm.get('ccEmail').errors?.email||senderForm.get('ccEmail').errors?.pattern">Ingrese un email válido</div> -->
							<div *ngIf="senderForm.get('ccEmail').hasError('toAddress')">Ingrese un email válido</div>
							<div *ngIf="senderForm.get('ccEmail').errors?.maxLength">Ingrese menos de 320 carácteres</div>
						</div>
					</div>
				</div>
				<div class="form-group row mx-auto">
					<label for="ccoEmail" class="col-3 label-control">CCO</label>
					<div class="col-9">
						<input
							type="email"
							name="ccoEmail"
							class="form-control"
							formControlName="ccoEmail"
							autocomplete="new-password"
							[ngClass]="{
								'is-invalid': (senderFormRef.submitted && senderForm.controls['ccoEmail'].invalid) || (senderForm.controls['ccoEmail'].touched && senderForm.controls['ccoEmail'].invalid)
							}" />
						<div class="invalid-feedback" *ngIf="senderFormRef.submitted && (senderForm.controls['ccoEmail'].invalid || senderForm.controls['ccoEmail'].touched || senderForm.controls['ccoEmail'].dirty)">
							<div *ngIf="senderForm.get('ccoEmail').errors?.required">Campo Obligatorio</div>
							<!-- <div *ngIf="senderForm.get('ccoEmail').errors?.email||senderForm.get('ccoEmail').errors?.pattern">Ingrese un email válido</div> -->
							<div *ngIf="senderForm.get('ccoEmail').hasError('toAddress')">Ingrese un email válido</div>
							<div *ngIf="senderForm.get('ccoEmail').errors?.maxLength">Ingrese menos de 320 carácteres</div>
						</div>
					</div>
				</div>
				<div class="form-group row mx-auto">
					<div class="col-6">
						<div class="row">
							<div class="col-6 label-control mr-5" for="pdfCheckbox">Enviar PDF</div>
							<div class="col-5">
								<input type="checkbox" formControlName="sendPdfCheckbox" class="form-check-input" id="pdfCheckbox" />
							</div>
						</div>
					</div>
					<div class="col-6">
						<div class="row">
							<div class="col-5 label-control">Enviar XML</div>
							<div class="col-7">
								<input type="checkbox" formControlName="sendXmlCheckbox" class="form-check-input" id="xmlCheckbox" />
							</div>
						</div>
					</div>
					<div class="offset-3 col-9 pl-4">
						<!-- <div class="invalid-feedback-group invalid-feedback row pl-3" *ngIf="senderFormRef.submitted && (senderForm.controls['sendPdfCheckbox'].value == false && senderForm.controls['sendXmlCheckbox'].value == false)">
                            <div>Favor indicar por lo menos un documento a enviar</div>
                       </div> -->
						<div class="invalid-feedback-group invalid-feedback row pl-3" *ngIf="senderForm.errors?.mailRepeated && (senderForm.touched || senderForm.dirty || senderFormRef.submitted)">
							<div>Favor no repetir direcciones de correo</div>
						</div>
					</div>
				</div>
				<div class="form-group row mx-auto">
					<label for="email" class="col-3 label-control">Comentarios</label>
					<div class="col-9">
						<textarea
							type="text"
							name="comentarios"
							class="form-control"
							formControlName="comments"
							autocomplete="off"
							[ngClass]="{
								'is-invalid': (senderFormRef.submitted && senderForm.controls['comments'].invalid) || (senderForm.controls['comments'].touched && senderForm.controls['comments'].invalid)
							}"></textarea>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<div class="form-group position-relative has-icon-left mb-0">
					<button type="submit" id="add-contact-item" class="btn btn-success add-contact-item">
						<i class="la la-paper-plane-o d-lg-none"></i>
						<span class="d-none d-lg-block">Enviar</span>
					</button>
					<button type="button" class="btn btn-secondary ml-3" (click)="c('Cross click')">
						<span class="d-none d-lg-block">Cerrar</span>
					</button>
				</div>
			</div>
		</div>
	</form>
</ng-template>

<ng-template #anularNCDteModal let-d="dismiss" let-c="close">
	<div class="modal-lg">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Nota de Crédito de {{ nombreTipoNota }} para DTE</div>
				<div class="modal-wizard-desc">Indique tipo de Nota de Crédito e indique los detalles de la {{ nombreTipoNota }}</div>
			</div>
			<button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<app-anulador-dte #anularDteComponent [receivedDte]="dteToNullify" [dteReferences]="dteToNullifyReferences" (sendCloseRequestEmitter)="closeAnularDteModal()" (newCreditNoteRequest)="newCreditNote($event)" (typeOfNullfySelected)="getNullifyTypeName($event)"></app-anulador-dte>
	</div>
</ng-template>
<ng-template #anularNCDteExportModal let-d="dismiss" let-c="close">
	<div class="modal-lg">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Nota de Crédito de DTE Exportación</div>
				<div class="modal-wizard-desc">Indique tipo de Nota de Crédito e indique los detalles</div>
			</div>
			<button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<app-anulador-dte #anularDteComponent [receivedDte]="dteToNullify" [dteReferences]="dteToNullifyReferences" (sendCloseRequestEmitter)="closeAnularDteModal()" (newCreditNoteRequest)="newCreditNote($event)" (typeOfNullfySelected)="getNullifyTypeName($event)"></app-anulador-dte>
	</div>
</ng-template>
<ng-template #anularNDDteExportModal let-d="dismiss" let-c="close">
	<div class="modal-lg">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Nota de Débito de DTE Exportación</div>
				<div class="modal-wizard-desc">Indique tipo de Nota de Débito e indique los detalles</div>
			</div>
			<button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<app-anulador-dte #anularDteComponent [receivedDte]="dteToNullify" [dteReferences]="dteToNullifyReferences" [DebitoMode]="true" (sendCloseRequestEmitter)="closeAnularDteModal()" (newDebitNoteRequest)="newDebitNoteNullification($event)"></app-anulador-dte>
	</div>
</ng-template>
<ng-template #anularNDDteModal let-d="dismiss" let-c="close">
	<div class="modal-lg">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Nota de Débito de DTE</div>
				<div class="modal-wizard-desc">Indique tipo de Nota de Débito e indique los detalles</div>
			</div>
			<button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<app-anulador-dte #anularDteComponent [receivedDte]="dteToNullify" [dteReferences]="dteToNullifyReferences" [DebitoMode]="true" (sendCloseRequestEmitter)="closeAnularDteModal()" (newDebitNoteRequest)="newDebitNoteNullification($event)"></app-anulador-dte>
	</div>
</ng-template>

<ng-template #anularNDInterestsDTEModal let-d="dismiss" let-c="close">
	<div class="modal-lg">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Nota de Débito de DTE</div>
				<div class="modal-wizard-desc">Indique tipo de Nota de Débito e indique los detalles</div>
			</div>
			<button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<app-anulador-dte #anularDteComponent [receivedDte]="dteToNullify" [dteReferences]="dteToNullifyReferences" [DebitoMode]="true" (sendCloseRequestEmitter)="closeAnularDteModal()" (newDebitNoteRequest)="newDebitNoteInterest($event)"></app-anulador-dte>
	</div>
</ng-template>
<ng-template #cesionDteModal let-d="dimiss" let-c="close">
	<div class="modal-lg">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Cesión de Factura</div>
				<div class="modal-wizard-desc">Indique los datos de la cesión del documento</div>
			</div>
			<button class="btn btn-info" (click)="openInfoModal()">
				<i class="fa fa-info-circle mr-1"></i> Requisitos previos para ceder factura
			</button>
		</div>
		<div *ngIf="showInfoModal" class="modal fade show d-block" tabindex="-1" role="dialog" style="background: rgba(0,0,0,0.5);">
			<div class="modal-dialog modal-xl modal-dialog-centered" role="document">
				<div class="modal-content">

				<div class="modal-header">
					<h5 class="modal-title">
					<i class="fa fa-info-circle mr-2 text-info"></i>
					Requisitos previos para ceder factura
					</h5>
					<button type="button" class="close" (click)="closeInfoModal()">
					<span aria-hidden="true">&times;</span>
					</button>
				</div>

				<div class="modal-body p-0" style="height: 75vh;">
					<iframe
					src="https://www.canva.com/design/DAHDFkDNfPo/URuQU1PHWYjsY3G5BQyTIQ/view?embed"
					allowfullscreen
					allow="fullscreen"
					style="width: 100%; height: 100%; border: none;">
					</iframe>
				</div>

				<div class="modal-footer">
					<button type="button" class="btn btn-secondary" (click)="closeInfoModal()">Cerrar</button>
				</div>

				</div>
			</div>
		</div>
		<app-cesion-dte [receivedDte]="selectedItem" (sendCloseRequestEmitter)="closeCesionDteModal()" (sendCesionRequestEmitter)="sendCesionDteRequest($event)"></app-cesion-dte>
	</div>
</ng-template>


<ng-template #datePickerImportedDteSiiModal let-d="dismiss">
	<div class="modal-content">
		<form (ngSubmit)="importDteSii(request)" #request="ngForm">
			<div class="modal-header">
				<div class="modal-wizard-label">
					<div class="modal-wizard-title">Importación Dte desde el SII</div>
					<div class="modal-wizard-desc">Indique fecha para lectura de datos en el S.I.I.</div>
				</div>
			</div>
			<div class="modal-body">
				<div class="form-group row mx-auto">
					<div class="col-4 label-control pt-3">Fecha</div>
					<div class="col-8">
						<input type="text" name="dateConciliacion" [maxDate]="todayString" ngxDaterangepickerMd [locale]="locale" (change)="detectChangeDate($event)" (input)="detectChangeDate($event)" [(ngModel)]="dateConciliacion" class="form-control" [singleDatePicker]="true" [autoApply]="true" [autocomplete]="false" [showDropdowns]="true" />
						<div *ngIf="request.submitted && (dateConciliacion.startDate == null || dateConciliacion == '' || !validDate)" class="invalid-feedback-group">
							<div *ngIf="dateConciliacion.startDate == null">Campo requerido</div>
							<div *ngIf="!validDate && locale.format == 'MM/YYYY'">Fecha inválida, use el formato mm/yyyy</div>
						</div>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<div class="form-group position-relative has-icon-left mb-0">
					<button type="submit" id="add-contact-item" class="btn btn-success add-contact-item">
						<i class="la la-paper-plane-o d-lg-none"></i>
						<span class="d-none d-lg-block">Importar</span>
					</button>
					<button type="button" class="btn btn-secondary ml-3" (click)="d('Cross click')">
						<span class="d-none d-lg-block">Cerrar</span>
					</button>
				</div>
			</div>
		</form>
	</div>
</ng-template>

<ng-template #importBoletasSiiModal let-d="dismiss">
	<div class="modal-content">
		<form (ngSubmit)="confirmImportBoletasSii(requestBoletas)" #requestBoletas="ngForm">
			<div class="modal-header">
				<div class="modal-wizard-label">
					<div class="modal-wizard-title">Importar boletas desde el SII</div>
					<div class="modal-wizard-desc">Boletas electrónicas afectas y exentas, tipos 39 y 41.</div>
				</div>
				<button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body">
				<p>
					Esta opción permite importar boletas electrónicas afectas y exentas, tipos 39 y 41, registradas en el SII y que aún no existen en SimpleFactura.
				</p>
				<p>
					Por disposición del SII, el reporte detallado de cada período mensual se genera una vez al día por contribuyente y ambiente. Si vuelves a solicitar el mismo período durante el día, el SII entregará el mismo reporte, aunque posteriormente se hayan emitido nuevas boletas.
				</p>

				<div *ngIf="importacionBoletasLoading" class="alert alert-info mb-2">
					Consultando estado de importación...
				</div>

				<div *ngIf="importacionBoletasStatus && importacionBoletasStatus.estado == 'Exitosa'" class="alert alert-warning mb-2">
					<p class="mb-1">
						La importación de boletas del SII para el período {{ formatImportacionBoletasPeriodo() }} ya fue realizada hoy, {{ formatImportacionBoletasFecha(importacionBoletasStatus.fechaUltimaImportacion) }}, en el ambiente de {{ importacionBoletasStatus.ambiente }}.
					</p>
					<p class="mb-2">Por disposición del SII, este período estará disponible nuevamente el próximo día. Puedes seleccionar otro mes.</p>
					<div>Modalidad: {{ importacionBoletasStatus.modalidad }}</div>
					<div>Boletas recibidas en el reporte: {{ importacionBoletasStatus.totalBoletasReporte || 0 }}</div>
					<div>Boletas pertenecientes al período: {{ importacionBoletasStatus.totalBoletasPeriodo || 0 }}</div>
					<div>Boletas existentes: {{ importacionBoletasStatus.totalBoletasExistentes || 0 }}</div>
					<div>Boletas nuevas importadas: {{ importacionBoletasStatus.totalBoletasNuevas || 0 }}</div>
				</div>

				<div *ngIf="importacionBoletasStatus && importacionBoletasStatus.estado == 'EnProceso'" class="alert alert-info mb-2">
					<p class="mb-2">Existe una importación de boletas para el período {{ formatImportacionBoletasPeriodo() }} en proceso desde {{ formatImportacionBoletasFecha(importacionBoletasStatus.fechaInicio) }} en el ambiente de {{ importacionBoletasStatus.ambiente }}.</p>
					<button type="button" class="btn btn-secondary btn-sm" (click)="refreshImportBoletasSiiStatus()">Actualizar estado</button>
				</div>

				<div *ngIf="importacionBoletasStatus && importacionBoletasStatus.estado == 'Fallida'" class="alert alert-danger mb-2">
					La última importación no pudo completarse. Puedes volver a intentarlo.
				</div>

				<fieldset [disabled]="importacionBoletasLoading">
					<div class="form-group row mx-auto">
						<div class="col-4 label-control pt-3">Mes</div>
						<div class="col-8">
							<input type="text" name="dateImportacionBoletas" [maxDate]="todayString" ngxDaterangepickerMd [locale]="localeBoletas" (change)="detectChangeDateImportacionBoletas($event)" (input)="detectChangeDateImportacionBoletas($event)" [(ngModel)]="dateImportacionBoletas" class="form-control" [singleDatePicker]="true" [autoApply]="true" [autocomplete]="false" [showDropdowns]="true" required />
							<div *ngIf="requestBoletas.submitted && (dateImportacionBoletas.startDate == null || dateImportacionBoletas == '' || !validDateImportacionBoletas)" class="invalid-feedback-group">
								<div *ngIf="dateImportacionBoletas.startDate == null">Campo requerido</div>
								<div *ngIf="!validDateImportacionBoletas">Fecha inválida, use el formato mm/yyyy</div>
							</div>
						</div>
					</div>
				</fieldset>
			</div>
			<div class="modal-footer">
				<div class="form-group position-relative has-icon-left mb-0">
					<button type="submit" id="import-boletas-sii-item" class="btn btn-success add-contact-item" [disabled]="importacionBoletasBloqueada() || importacionBoletasLoading">
						<i class="la la-paper-plane-o d-lg-none"></i>
						<span class="d-none d-lg-block">Importar</span>
					</button>
					<button type="button" class="btn btn-secondary ml-3" (click)="d('Cross click')">
						<span class="d-none d-lg-block">Cerrar</span>
					</button>
				</div>
			</div>
		</form>
	</div>
</ng-template>

<!-- <ng-template #datePickerExportModal let-d="dismiss">
	<div class="modal-content">
		<form (ngSubmit)="exportToExcel(requestExport)" #requestExport="ngForm">
			<div class="modal-header">
				<div class="modal-wizard-label">
					<div class="modal-wizard-title">Exportación de datos a Excel</div>
					<div class="modal-wizard-desc">Indique rango de fechas para exportación de datos.</div>
				</div>
			</div>
			<div class="modal-body">
				<div class="form-group row mx-auto">
					<div class="col-4 label-control pt-3">Rango de Fechas</div>
					<div class="col-8">
						<input type="text" name="dateExportacion" [maxDate]="todayString" ngxDaterangepickerMd [locale]="locale" (change)="detectExportChangeDate($event)" (input)="detectChangeDate($event)" [(ngModel)]="dateExportacion" class="form-control" [singleDatePicker]="false" [autoApply]="true" [autocomplete]="false" [showDropdowns]="true" />
						<div *ngIf="requestExport.submitted && (dateExportacion.startDate == null || dateExportacion == '' || !validDate)" class="invalid-feedback-group">
							<div *ngIf="dateExportacion.startDate == null">Campo requerido</div>
							<div *ngIf="!validDate && locale.format == 'MM/YYYY'">Fecha inválida, use el formato mm/yyyy</div>
						</div>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<div class="form-group position-relative has-icon-left mb-0">
					<button type="submit" id="add-contact-item" class="btn btn-success add-contact-item">
						<i class="la la-paper-plane-o d-lg-none"></i>
						<span class="d-none d-lg-block">Exportar</span>
					</button>
					<button type="button" class="btn btn-secondary ml-3" (click)="d('Cross click')">
						<span class="d-none d-lg-block">Cerrar</span>
					</button>
				</div>
			</div>
		</form>
	</div>
</ng-template> -->

<ng-template #referenciaModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title">Origen del Documento a Referenciar</h4>
		<button type="button" class="close" (click)="modal.dismiss()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<p>
			¿El documento que deseas referenciar fue emitido mediante SimpleFactura o utilizaste otro proveedor? <br />
			Recuerda que la nota de {{ nombreDte }} debe referenciar a otro documento.
		</p>
	</div>
	<div class="modal-footer">
		<button class="btn btn-primary" (click)="opcionSimpleFactura(modal)">SimpleFactura</button>
		<button class="btn btn-secondary" (click)="opcionOtroProveedor(modal)">Otro Proveedor</button>
	</div>
</ng-template>

<ng-template #imagenModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title">Ubicación de Generar ND/NC</h4>
		<button type="button" class="close" (click)="modal.dismiss()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body text-center">
		<img src="assets/media/gifs/gif_NC_ND.gif" alt="Generar ND/NC" class="img-fluid imagenmodal" />
	</div>
	<div class="modal-footer">
		<button class="btn btn-primary" (click)="modal.close()">Cerrar</button>
	</div>
</ng-template>
